import axios from "./axios-config";

export const getAllComments = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/comments?keywords=${keyword ?? ""}&page=${page}`)
    return (data);

}
export const getAllUnverifiedComments = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/unverified-comments?keywords=${keyword ?? ""}&page=${page}`)
    return (data);

}

export const getSingleComment = async (id) => {

    let { data } = await axios.get(`/super-admin/comments/` + id)
    return data;

}
export const deleteSingleComment = async (id) => {
    let { data } = await axios.delete(`/super-admin/comments/` + id)
    return data;
}

export const updateSingleComments = async (id, updateData) => {

    let { data } = await axios.post(`/super-admin/comments/${id}?_method=put`, updateData)
    return data;
}

export const storeSingleComments = async (storeData) => {

    let { data } = await axios.post(`/super-admin/reply-comment/`+storeData.id, storeData.data)
    return data
}
export const confirmComment = async (id) => {

    let { data } = await axios.post(`/super-admin/confirm-comment/` + id)
    return data
}
export const disapproveComment = async (id) => {

    let { data } = await axios.post(`/super-admin/cancellation-of-approval/` + id)
    return data
}


// export const getCommentComments = async (data) => {
//     let { data } =  await axios.post(`/super-admin/Comments/all/comments`, data)
//     return data;
// }

export const getWorkshopComments = async (data) => {
    try {
        let response = await axios.post(`/super-admin/Comments/all/workshops`, data)
        return (response.data);
    } catch (error) {
        return (error);
    }
}

